export const KEEP_ALIVE_URL = 'KEEPALIVEURL';
export const RESULT_URL = 'RESULTURL';
